import React from "react"
import { ITextProps, TextColor, TextWeight } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {}

const Body2 = (props: Props) => {
  const className = `font-raleway-medium text-xs sm:text-sm md:text-base ${mapStylesFromProps(
    {
      ...props,
      color: TextColor.DarkBlue,
      weight: TextWeight.Bold,
    }
  )}`
  return <span className={className}>{props.children}</span>
}

export default Body2
